export default __webpack_public_path__ + "static/media/salon_view.1124b077.jpeg";